import { SUCCESS, FETCH_MAP } from '../constants/actionApi';
import { addOrUpdateItemsInState } from '../helpers/data';
import initialState from '../store/initialState';
import { SC_MAP, UPDATED } from '../constants/socket';

export default (state = initialState.maps, { type, payload }) => {
  switch (type) {
    case FETCH_MAP + SUCCESS:
    case SC_MAP + UPDATED:
      return addOrUpdateItemsInState(state, payload.data);
    default:
      return state;
  }
};
